<div class="service-list-container">

  <!-- Premium Header Banner -->
  <div class="list-header-banner">
    <div class="header-overlay"></div>
    <div class="header-content">
      <div class="breadcrumbs">
        <a routerLink="/wedding-services">Home</a> <span class="material-symbols-outlined">chevron_right</span> <span>{{
          displayCategoryName }}</span>
      </div>
      <h1>Top {{ displayCategoryName }} Vendors</h1>
      <p>Find the best professionals for your special day</p>
    </div>
  </div>

  <div class="marketplace-layout">

    <!-- Sidebar Filters (Mock UI) -->
    <aside class="filter-sidebar">
      <div class="filter-header">
        <h3>Filters</h3>
        <button class="btn-clear" (click)="clearFilters()">Clear All</button>
      </div>

      <!-- City Filter -->
      <div class="filter-section">
        <h4>Location / City</h4>
        <div class="city-dropdown">

  <!-- Dropdown button -->
  <button
    type="button"
    class="city-dropdown-button"
    (click)="showCityDropdown = !showCityDropdown"
  >
    <span>
      {{ selectedCities.length > 0
        ? selectedCities.join(', ')
        : 'Select cities' }}
    </span>

    <span class="material-symbols-outlined">
      expand_more
    </span>
  </button>

  <!-- Dropdown content -->
  <div
    class="city-dropdown-menu"
    *ngIf="showCityDropdown"
  >

    <!-- Search INSIDE dropdown -->
    <div class="city-search-box">
      <input
        type="text"
        placeholder="Search city..."
        [(ngModel)]="searchCity"
        (click)="$event.stopPropagation()"
      >
    </div>

    <!-- Cities -->
    <label
      class="city-option"
      *ngFor="let city of getFilteredCities()"
    >

      <input
        type="checkbox"
        [checked]="selectedCities.includes(city.city_nme)"
        (change)="onCityChange(city.city_nme, $event)"
      >

      <span>{{ city.city_nme }}</span>

    </label>

    <div
      class="no-city"
      *ngIf="getFilteredCities().length === 0"
    >
      No cities found
    </div>

  </div>

</div>
      </div>

      <!-- Rating Filter -->
      <!-- <div class="filter-section">
        <h4>Rating</h4>
        <div class="filter-options">
          <label class="custom-checkbox" *ngFor="let star of ratings">
            <input type="checkbox" [name]="'rating-' + star">
            <span class="checkmark"></span>
            <span class="stars">
              <span class="material-symbols-outlined" *ngFor="let i of [1,2,3,4,5]"
                [class.active]="i <= star">star</span>
            </span>
          </label>
        </div>
      </div> -->

      <!-- Budget Filter -->
      <!-- <div class="filter-section">
        <h4>Budget Range</h4>
        <select class="form-select">
          <option>Any Budget</option>
          <option>Under ₹50,000</option>
          <option>₹50,000 - ₹1,00,000</option>
          <option>Above ₹1,00,000</option>
        </select>
      </div> -->

    </aside>

    <!-- Main Content Area -->
    <main class="vendor-list-content">

      <div class="list-controls">
        <p class="results-count"><strong>{{ merchants.length }}</strong> vendors found</p>
        <div class="sort-by">
          <!-- <label>Sort by:</label>
          <select class="form-select">
            <option>Popularity</option>
            <option>Rating: High to Low</option>
            <option>Price: Low to High</option>
          </select> -->
        </div>
      </div>

      <!-- Loading State -->
      <div class="loading-state" *ngIf="loading">
        <div class="spinner"></div>
        <p>Loading vendors...</p>
      </div>

      <!-- Vendor Grid -->
      <div class="vendor-grid" *ngIf="!loading">

        <!-- No Results -->
        <div class="no-results" *ngIf="merchants.length === 0">
          <span class="material-symbols-outlined">sentiment_dissatisfied</span>
          <h3>No vendors found</h3>
          <p>We couldn't find any {{ displayCategoryName }} vendors in this area.</p>
        </div>

        <!-- Vendor Cards -->
        <div class="vendor-card" *ngFor="let merchant of merchants" (click)="openMerchant(merchant._id)">

          <div class="vendor-image">
            <img
              [src]="merchant?.profile_pic ? (merchant.profile_pic.startsWith('/') ? apiUrl + merchant.profile_pic : merchant.profile_pic) : 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&w=600&q=80'"
              alt="Vendor Image">
            <div class="premium-badge" *ngIf="merchant.subscriptionTier === 'PREMIUM'">
              <span class="material-symbols-outlined">workspace_premium</span> Premium
            </div>
            <button
  type="button"
  class="wishlist-btn"
  [class.shortlisted]="isMerchantShortlisted(merchant._id)"
  (click)="toggleShortlist(merchant, $event)"
>
  <span
    class="material-symbols-outlined heart-icon"
    [class.filled]="isMerchantShortlisted(merchant._id)"
  >
    {{ isMerchantShortlisted(merchant._id) ? 'favorite' : 'favorite_border' }}
  </span>
</button>
          </div>

          <div class="vendor-details">
            <div class="title-row">
              <h3>{{ merchant.business_name || merchant.businessName }}</h3>
              <div class="rating">
                <span class="material-symbols-outlined star-icon">star</span>
                <strong>4.8</strong> <span>(120)</span>
              </div>
            </div>

            <div class="location-cat">
              <span class="cat">{{ merchant.category?.name || displayCategoryName }}</span>
              <span class="dot">•</span>
              <span class="loc"><span class="material-symbols-outlined">location_on</span> {{ merchant.location ||
                merchant.city || 'Chennai' }}<span *ngIf="merchant.district">, {{ merchant.district }}</span></span>
            </div>

            <div class="action-row">
              <button class="btn-primary-outline full-width">View Profile</button>
            </div>
          </div>

        </div>
      </div>

    </main>
  </div>
</div>